import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";

const className = "auth-focus auth-underline font-medium text-coral-700";

export const TextLink = ({
  children,
  to,
}: {
  children: ReactNode;
  to: string;
}) => (
  <Link className={className} to={to}>
    {children}
  </Link>
);

export const TextButton = ({
  children,
  className: extra,
  ...button
}: { children: ReactNode } & ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    className={cn(className, "border-0 bg-transparent p-0", extra)}
    type="button"
    {...button}
  >
    {children}
  </button>
);
